import React, { useEffect, useRef, useState } from 'react';
import { AuthCard, AuthMessage } from '../SignInScreens';
import { portalApi, portalErrorMessage } from './portalApi';

// Opened from the link sent to a new login email (/portal/confirm-email
// ?token=..., issue #256). Confirms the change straight away; the login
// signs in with the new address from then on. Needs no session, since the
// new inbox is often on another device.

export const PORTAL_CONFIRM_EMAIL_PATH = '/portal/confirm-email';

const PRIMARY_LINK = { display: 'inline-block', padding: '8px 14px', color: '#fff', background: '#1976d2', borderRadius: 6, fontSize: 13, textDecoration: 'none' };

function PortalConfirmEmailScreen() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [result, setResult] = useState(null); // { email, portal_name }
  const [error, setError] = useState('');
  const sent = useRef(false);

  useEffect(() => {
    // A link works once, so the request is sent only once per page load.
    if (sent.current) return;
    sent.current = true;
    portalApi.post('/api/portal-auth/confirm-email', { token })
      .then((res) => setResult(res.data.data))
      .catch((err) => setError(portalErrorMessage(err, 'This link isn\'t valid.')));
  }, [token]);

  if (error) {
    return (
      <AuthCard portal subtitle="This link can't be used">
        <div style={{ fontSize: 14 }}>{error}</div>
      </AuthCard>
    );
  }
  if (!result) return <AuthMessage>Confirming your new login email...</AuthMessage>;

  return (
    <AuthCard portal subtitle="Login email changed">
      <div style={{ fontSize: 14, marginBottom: 20 }}>
        From now on, sign in with <strong>{result.email}</strong>.
      </div>
      <a href={`/portal/${encodeURIComponent(result.portal_name)}`} style={PRIMARY_LINK}>Go to the portal</a>
    </AuthCard>
  );
}

export default PortalConfirmEmailScreen;
